module.exports = __webpack_public_path__ + "static/media/8OLA21.9695d028.jpg";